import { MembershipIncomingRenewal } from '@models/membership/MembershipIncomingRenewal'
import { membershipIncomingRenewalSchema } from '@models/schema'
import { createSelector, createSlice } from '@reduxjs/toolkit'
import { fetchMembershipIncomingRenewals } from '@services/membership/MembershipIncomingRenewalService'
import { RootState } from '@store/store'
import {
  baseReducers,
  SBAPI,
  SBSelectRaw,
  SBState,
} from '@supplement-bacon/react-toolkit/utils'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'

const initialState: SBState<MembershipIncomingRenewal> = {
  isLoading: false,
  error: null,
  items: {},
  ids: [],
  selectedId: undefined,
  query: initialQuery,
}

const slice = createSlice({
  name: 'membershipIncomingRenewal',
  initialState,
  reducers: baseReducers,
})

// Reducer
export default slice.reducer
export const {
  getItemsSuccess: getMembershipIncomingRenewalsSuccess,
  setQuery: setMembershipIncomingRenewalQuery,
  reset: resetMembershipIncomingRenewalState,
  resetQueryAndIds: resetMembershipIncomingRenewalQueryAndIds,
} = slice.actions

/**
 * Selectors
 */

const selectRawItems: SBSelectRaw<
  RootState,
  { [key: number]: MembershipIncomingRenewal }
> = (state: RootState) => state[slice.name].items
const selectRawIds: SBSelectRaw<RootState, number[]> = (state: RootState) =>
  state[slice.name].ids

export const selectMembershipIncomingRenewals = () =>
  createSelector(
    [selectRawItems, selectRawIds],
    (items, ids) => (ids ?? []).map((id) => items[id]).filter((i) => i)
    // Filter allow to return only non-null elements
  )
/**
 * Actions
 */

export const getMembershipIncomingRenewals = (params: TableParams) =>
  SBAPI.FetchPaginatedDispatched(
    fetchMembershipIncomingRenewals(params),
    // Array schema: see `MembershipTransactionReducer` - a bare entity schema
    // normalizes a list into `result: undefined`, i.e. no rows at all.
    [membershipIncomingRenewalSchema],
    slice.actions
  )
